import { render, staticRenderFns } from "./list_tips_component.vue?vue&type=template&id=f1ca4fc2&scoped=true"
import script from "./list_tips_component.vue?vue&type=script&lang=js"
export * from "./list_tips_component.vue?vue&type=script&lang=js"
import style0 from "./list_tips_component.vue?vue&type=style&index=0&id=f1ca4fc2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ca4fc2",
  null
  
)

export default component.exports